<template>
  <main role="main">
    <notfound home-link="/app/clients" />
  </main>
</template>

<script>
import { notfound } from '@/components/layout';
import getBrandConfig from '@/lib/utils/get_brand_config';

const brandConfig = getBrandConfig();

export default {
  route: {
    path: '/app/*',
    priority: -1,
  },

  head() {
    const title = this.$t('Page not found (404)');
    return {
      title: `${title} | ${brandConfig.fullName}`,
    };
  },

  components: { notfound },
};
</script>

<style lang="scss" scoped>


  main {
    padding-top: 5.5rem;

    @media #{$screen-width-medium} {
      padding-top: 0;
    }
  }
</style>
